import { Link } from 'react-router-dom';

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  linkText?: string;
  linkTo?: string;
}

export default function SectionTitle({ eyebrow, title, desc, linkText, linkTo }: SectionTitleProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div>
        {eyebrow ? (
          <span className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            <span className="h-3 w-1 rounded-full bg-primary-500"></span>
            {eyebrow}
          </span>
        ) : null}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc ? <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-500">{desc}</p> : null}
      </div>
      {linkText && linkTo ? (
        <Link
          to={linkTo}
          className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
        >
          {linkText}
          <i className="ri-arrow-right-line"></i>
        </Link>
      ) : null}
    </div>
  );
}